import {
  getNameDescriptionTableColumn,
} from '@/utils/common/tableColumn'
// import i18n from '@/locales'
// import { currencyUnitMap } from '@/constants/currency'
import currencyRequest from '@Bill/mixins/currencyRequest'
// import { numerify } from '@/filters'

export default {
  mixins: [currencyRequest],
  created () {
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        field: 'origin_res_type',
        hideField: true,
        edit: false,
        editDesc: false,
        showDesc: false,
        addBackup: true,
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ this.getResName(row.origin_res_type) }</side-page-trigger>
          )
        },
        formatter: ({ row }) => {
          return this.getResName(row.origin_res_type)
        },
      }),
      // {
      //   field: 'amount',
      //   title: i18n.t('bill.text_141'),
      //   sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.amount, '0,0.00')}`
      //   },
      // },
      // {
      //   field: 'year_amount',
      //   title: i18n.t('bill.text_139'),
      //   // sortable: true,
      //   formatter: ({ row }) => {
      //     let sign = ''
      //     if (currencyUnitMap[this.currency]) {
      //       sign = currencyUnitMap[this.currency].sign || ''
      //     }
      //     return `${sign}${numerify(row.year_amount, '0,0.00')}`
      //   },
      // },
    ]
  },
  methods: {
    getResName (name) {
      // if (this.$te(`bill_resource_type.${name}`)) {
      //  return this.$t(`bill_resource_type.${name}`)
      // }
      return name
    },
  },
}
